export default __webpack_public_path__ + "static/cardBg1-62d8938bc79304ef94442290ec9de191.png";